<template>
  <div class="app-container">
    <div class="tip01">
      {{ $t('placeOrder.automaticPrinting1') }}
      <el-link
        :href="$store.getters.expressWmsPluginLink"
        style="font-size: 16px"
        type="warning"
      >{{ $t('placeOrder.automaticPrinting2') }}
      </el-link>
      {{ $t('placeOrder.automaticPrinting3') }}
    </div>
    <el-form
      ref="ruleFormRef"
      :inline="false"
      :model="queryForm"
      label-position="top"
      size="large"
      @submit.native.prevent
    >
      <el-form-item prop="waybillBagNumber">
        <el-select v-model="selectNum" style="width: 150px;margin-top: 10px;margin-right: 5px" @change="changeNum">
          <el-option :label="$t('GlobalSetObj.scannerNumber')" :value="1" />
          <el-option :label="$t('newOrder.InvoiceKey')" :value="2" />
        </el-select>
        <el-input
          v-if="selectNum === 1"
          ref="inputRef"
          v-model.trim="queryForm.waybillBagNumber"
          clearable
          style="width: 350px"
          @keyup.enter.native="arrivedOut"
        />
        <el-input
          v-if="selectNum === 2"
          v-model.trim="queryForm.invoiceSecretKeys"
          clearable
          style="width: 350px"
          @keyup.enter.native="arrivedOut"
        />
      </el-form-item>
    </el-form>
    <el-divider style="height: 2px;margin: 22px 0" />
    <el-form>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item>
            <el-select v-model="selectTime" size="small" style="width: 150px">
              <el-option :label="$t('orderCenterCont.anjunWaybillNumber')" :value="1" />
            </el-select>
            <el-input
              v-model="queryForm.waybillNumbers"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1" type="textarea"
              style="width: 100%" class="textClass"
              @blur="BlockNewline"
              @keydown.enter.native="BlockNewline"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--打印时间-->
          <el-form-item :label="$t('collectionCenter.printTime')">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('collectionCenter.EndTime')"
              range-separator="—"
              :start-placeholder="$t('collectionCenter.StartTime')"
              style="width: 100%"
              size="small"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="timeChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--客户名称-->
          <el-form-item :label="$t('collectionCenter.CustomerName')">
            <el-select
              v-model="queryForm.customerIds"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              clearable filterable multiple
              remote reserve-keyword
              :remote-method="getCustomerPage"
              style="width: 100%" size="small"
              @clear="getCustomerPage"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--操作网点-->
          <el-form-item :label="$t('collectionCenter.OperationSite')">
            <el-select
              v-model="queryForm.printableSiteIds"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              clearable filterable multiple
              style="width: 100%" size="small"
              remote reserve-keyword
              :remote-method="remoteGetSiteList"
              @clear="remoteGetSiteList"
            >
              <el-option
                v-for="item in siteList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--操作人-->
          <el-form-item :label="$t('collectionCenter.operator')">
            <el-select
              v-model="queryForm.printableUserIds"
              :placeholder="$t('GlobalSetObj.Only10AreDisplayed')"
              clearable filterable multiple
              remote reserve-keyword
              :remote-method="getOperator"
              style="width: 100%;" size="small"
              @clear="getOperator"
            >
              <el-option
                v-for="(item, index) in operatorList"
                :key="index"
                :label="item.realName + '（' + item.username + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-bottom: 20px">
        <el-button
          size="small"
          type="primary"
          @click="getSearch"
        >{{ $t('newOrder.search') }}</el-button><!-- 搜索 -->
        <el-button
          size="small"
          type="info"
          @click="reset"
        >{{ $t('newOrder.reset') }}</el-button><!-- 重置 -->
        <el-button
          size="small"
          type="success"
          @click="downloadAll"
        >{{ $t('collectionCenter.allExport') }}</el-button><!-- 全部导出 -->
      </div>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      height="600"
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="100"
      />
      <el-table-column
        :label="$t('collectionCenter.scanInfo')"
        min-width="180"
        prop="scanInformation"
        align="center"
      />
      <el-table-column
        :label="$t('orderCenterCont.anjunWaybillNumber')"
        min-width="160"
        prop="waybillNumber"
        align="center"
      >
        <template #default="scope">
          <div>{{ scope.row.waybillNumber || '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('collectionCenter.CustomerName')"
        min-width="180"
        prop="customerName"
        align="center"
      />
      <el-table-column
        :label="$t('collectionCenter.printTime')"
        min-width="180"
        prop="printableTime"
        align="center"
      />
      <el-table-column
        :label="$t('collectionCenter.operator')"
        min-width="150"
        prop="printableUserName"
        align="center"
      />
      <el-table-column
        :label="$t('collectionCenter.OperationSite')"
        min-width="150"
        prop="printableSite"
        align="center"
      />
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[50, 100, 200, 400]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 打印面单  -->
    <div style="display: none">
      <pdf ref="pdfPrint" :src="viewUrl" />
    </div>
    <!-- 隐藏提示音 -->
    <div v-show="false">
      <audio ref="errRef" :src="errorMp3" controls="controls" />
      <audio ref="okRef" :src="okMp3" controls="controls" />
    </div>
    <el-dialog
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="printTipsVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="printTips_class">
        <div class="printTips_title">
          <!-- 请选择需要打印的运单号 -->
          {{ $t('collectionCenter.selectWaybill') }}
        </div>
        <el-radio-group v-model="checkList">
          <!-- 原单号 -->
          <el-radio :label="1">{{ $t('collectionCenter.originalWaybill') }}：{{ printTips.forwardWaybillNumber }}</el-radio>
          <!-- 退件单号 -->
          <el-radio :label="2">{{ $t('collectionCenter.returnNoteNum') }}：{{ printTips.waybillNumber }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button size="small" @click="handleClose">{{ $t('roleManage.cancel') }}</el-button>
        <!-- 确认 -->
        <el-button size="small" type="primary" @click="submitPr">{{ $t('roleManage.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList.js';
import { getUserPage } from '@/api/user';
import { siteFuzzyQuery } from '@/api/lanshou';
import { apiCustomerPage } from '@/api/customer';
import { quickOrderChange, waybillPrintablePage, checkWaybillNumber, waybillPrintableExportAll } from '@/api/automaticSorting';
import { batchPdfDownload } from '@/utils/PDF_util';
import pdf from 'vue-pdf-messy-code-fix';
import { apiStartUp, autoPrint } from '@/api/serialPort';

const okMp3 = 'https://anjunggl-1313947203.cos.ap-guangzhou.myqcloud.com/app/static/music/su.wav';
const errorMp3 =
  'https://anjunggl-1313947203.cos.ap-guangzhou.myqcloud.com/app/static/music/print_error.wav';
export default {
  name: 'QuickOrderChange',
  components: {
    pdf
  },
  data() {
    return {
      operatorList: [], // 操作人列表
      siteList: [], // 操作网点列表
      customerList: [], // 客户列表
      timeValue: [],
      selectTime: 1,
      selectNum: 1,
      checkList: '',
      printTipsVisible: false,
      printTips: {
        forwardWaybillNumber: '',
        waybillNumber: ''
      },
      viewUrl: '',
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        pageSize: 50,
        pageNumber: 1,
        total: 0,
        waybillBagNumber: '',
        invoiceSecretKeys: '',
        waybillNumbers: '',
        beginPrintDate: '',
        endPrintDate: '',
        customerIds: [],
        printableSiteIds: [],
        printableUserIds: []
      },
      tableData: [],
      okMp3,
      errorMp3
    };
  },
  activated() {
    this.$nextTick((_) => {
      this.$refs.inputRef.$refs.input.focus();
    });
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.$nextTick((_) => {
      this.$refs.inputRef.$refs.input.focus();
    });
    this.getCustomerPage('');
    this.remoteGetSiteList('');
    this.getOperator('');
    this.reset(); // 重置+查询
  },
  methods: {
    BlockNewline() {
      if (this.queryForm.waybillNumbers) {
        let lines = this.queryForm.waybillNumbers.split('\n')
          .filter(line => line && line.trim())
          .map(line => line.replace(/\s/g, '').trim());
        if (lines.length > 2000) {
          lines = lines.slice(0, 2000);
          this.$message.warning(this.$t('collectionCenter.intercep2'));
        }
        this.queryForm.waybillNumbers = lines.join('\n');
        console.log('waybillNumbers', this.queryForm.waybillNumbers);
      }
    },
    timeChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.beginPrintDate = '';
        this.queryForm.endPrintDate = '';
      }
      this.queryForm.beginPrintDate = val[0];
      this.queryForm.endPrintDate = val[1];
    },
    // 客户名称列表
    getCustomerPage(name = '') {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 操作网点列表
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data;
        }
      });
    },
    // 操作人数据
    getOperator(name) {
      const queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          realName: name
        }
      };
      getUserPage(queryForm).then(res => {
        if (res.code === 200) {
          this.operatorList = res.data.records;
        }
      });
    },
    downloadAll() {
      if (this.tableData.length <= 0) {
        // '无可导出数据'
        this.$message.warning(this.$t('collectionCenter.noDataExport'));
        return;
      }
      const data = {
        waybillNumbers: this.queryForm.waybillNumbers ? this.queryForm.waybillNumbers.split('\n') : [],
        invoiceSecretKeys: [],
        beginPrintDate: this.queryForm.beginPrintDate,
        endPrintDate: this.queryForm.endPrintDate,
        customerIds: this.queryForm.customerIds,
        printableSiteIds: this.queryForm.printableSiteIds,
        printableUserIds: this.queryForm.printableUserIds
      };
      waybillPrintableExportAll(data).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    reset() {
      const d = new Date();
      const day = dayjs(d).format('YYYY-MM-DD');
      this.timeValue = [day + ' 00:00:00', day + ' 23:59:59'];
      this.queryForm = {
        pageSize: 50,
        pageNumber: 1,
        total: 0,
        waybillBagNumber: '',
        invoiceSecretKeys: '',
        waybillNumbers: '',
        beginPrintDate: day + ' 00:00:00',
        endPrintDate: day + ' 23:59:59',
        customerIds: [],
        printableSiteIds: [],
        printableUserIds: []
      };
      this.selectTime = 1;
      this.getSearch();
    },

    changeNum() {
      this.queryForm.waybillBagNumber = '';
      this.queryForm.invoiceSecretKeys = '';
    },
    handleClose() {
      this.printTipsVisible = false;
      this.checkList = '';
      this.printTips = {
        forwardWaybillNumber: '',
        waybillNumber: ''
      };
    },
    printedSheet(url) {
      const labelList = [url];
      // 手动显示加载中动画
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$i18n.t('orderCenterCont.DesperatelyLoading'), // '拼命加载中',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      batchPdfDownload(labelList)
        .then((res) => {
          this.viewUrl = res;
          setTimeout(() => {
            this.$refs.pdfPrint.print();
          }, 300);
        })
        .finally(() => {
          loading.close();
        });
    },
    // 查询
    getSearch() {
      this.queryForm.pageNumber = 1;
      this.page();
    },
    page() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          waybillNumbers: this.queryForm.waybillNumbers ? this.queryForm.waybillNumbers.split('\n') : [],
          invoiceSecretKeys: [],
          beginPrintDate: this.queryForm.beginPrintDate,
          endPrintDate: this.queryForm.endPrintDate,
          customerIds: this.queryForm.customerIds,
          printableSiteIds: this.queryForm.printableSiteIds,
          printableUserIds: this.queryForm.printableUserIds
        }
      };
      waybillPrintablePage(data).then((res) => {
        if (res.status === 'OK') {
          this.tableData = res.data.records;
          this.queryForm.total = res.data.total;
        }
      });
    },
    // 扫描
    arrivedOut() {
      if (this.queryForm.waybillBagNumber && !this.queryForm.invoiceSecretKeys) {
        checkWaybillNumber(this.queryForm.waybillBagNumber).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.printTipsVisible = true;
              this.printTips = {
                forwardWaybillNumber: res.data.forwardWaybillNumber,
                waybillNumber: res.data.waybillNumber
              };
            } else {
              this.submitPr();
            }
          }
        });
      } else if (!this.queryForm.waybillBagNumber && this.queryForm.invoiceSecretKeys) {
        this.submitPr();
      } else {
        this.getSearch();
      }
    },
    submitPr() {
      const _this = this;
      let waybillNumber = '';
      if (this.printTips.forwardWaybillNumber) {
        waybillNumber = this.checkList === 1 ? this.printTips.forwardWaybillNumber : this.checkList === 2 ? this.printTips.waybillNumber : '';
        if (!waybillNumber) {
          this.$message.warning(this.$t('GlobalSetObj.pleaseChoose'));
          return;
        }
      } else {
        if (this.selectNum === 1) {
          waybillNumber = this.queryForm.waybillBagNumber;
        } else {
          waybillNumber = this.queryForm.invoiceSecretKeys;
        }
      }
      const data = {
        waybillNumbers: [],
        invoiceSecretKeys: []
      };
      if (this.selectNum === 1) {
        data.waybillNumbers = [waybillNumber];
      } else {
        data.invoiceSecretKeys = [waybillNumber];
      }
      quickOrderChange(data)
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            apiStartUp()
              .then((res1) => {
                if (res1.code === 200) {
                  console.log(res1);
                  autoPrint(res.data[0].labelUrl)
                    .then(async(resPrint) => {
                      if (resPrint.code === 200) {
                        await this.$refs.okRef.play();
                        this.$message.success(this.$t('collectionCenter.printSuc'));
                        _this.queryForm.waybillBagNumber = '';
                        _this.queryForm.invoiceSecretKeys = '';
                        _this.$nextTick((_) => {
                          _this.$refs.inputRef.$refs.input.focus();
                        });
                        _this.getSearch();
                        _this.printTipsVisible = false;
                      }
                    })
                    .catch(async(e) => {
                      await this.$refs.errRef.play();
                      this.$message.error(this.$t('GlobalSetObj.PrintFailure'));
                      // this.ruleForm.SingleNumber = '';
                      _this.$nextTick((_) => {
                        _this.$refs.SingleNumberInput.$refs.input.select();
                      });
                    });
                } else {
                  this.$refs.errRef.play();
                  this.$message.error(this.$t('GlobalSetObj.setDefaultPrinter'));
                  _this.$nextTick((_) => {
                    _this.$refs.inputRef.$refs.input.select();
                  });
                }
              })
              .catch(() => {
                this.$refs.errRef.play();
                this.$message.error(this.$t('GlobalSetObj.setDefaultPrinter'));
                _this.$nextTick((_) => {
                  _this.$refs.inputRef.$refs.input.select();
                });
              });
          }
        })
        .catch(() => {
          this.$nextTick((_) => {
            this.$refs.inputRef.$refs.input.select();
          });
        });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.page();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.page();
    }
  }
};
</script>

<style scoped>
.textClass >>> ::v-deep .el-textarea__inner{
  max-height: 200px;
}
.dialog-footer {
  text-align: center;
}
.dialog-footer >>> .el-button:first-child {
  margin-right: 20px;
}
.printTips_class {
  padding-top: 10px;
  padding-left: 40px;
  box-sizing: border-box;
}
.printTips_title {
  margin-bottom: 10px;
}
.printTips_class >>> .el-radio-group .el-radio {
  display: block !important;
  margin-bottom: 5px;
}
.app-container >>> .el-dialog__body {
  padding: 10px 20px;
}

.tip01 {
  background-color: #ecf5ff;
  color: #409eff;
  padding: 10px;
  font-size: 14px;
  border-radius: 5px;
}
</style>
